import { render, staticRenderFns } from "./BadgeDropdown.vue?vue&type=template&id=1cb2cf1f&scoped=true"
import script from "./BadgeDropdown.vue?vue&type=script&lang=js"
export * from "./BadgeDropdown.vue?vue&type=script&lang=js"
import style0 from "./BadgeDropdown.vue?vue&type=style&index=0&id=1cb2cf1f&prod&scoped=true&lang=css"
import style1 from "./BadgeDropdown.vue?vue&type=style&index=1&id=1cb2cf1f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb2cf1f",
  null
  
)

export default component.exports